const initialState = {
  paymentCode: '',
  biller: null,
};

const getters = {
  paymentCode: state => state.paymentCode,
  biller: state => state.biller,
};

const mutations = {
  SET_BILLER(state, biller) {
    state.biller = biller;
  },
  SET_PAYMENT_CODE(state, paymentCode) {
    state.paymentCode = paymentCode;
  },
};

const actions = {
  set({ commit }, { biller, paymentCode }) {
    commit('SET_BILLER', biller);
    commit('SET_PAYMENT_CODE', paymentCode);
  },
};

export default {
  getters,
  actions,
  mutations,
  namespaced: true,
  state: () => ({ ...initialState }),
};
